// client/src/App.jsx
import React, { useEffect } from 'react';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Solutions from './components/Solutions/Solutions';
import Portfolio from './components/Portfolio/Portfolio';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  
  return (
    <div>
      <Navbar />
      <Hero />
      <Solutions />
      <Portfolio />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
